var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import VideoPlayer from '../video-player';
const YOUTUBE_CONSENT_CATEGORY = '3';
let currentConsent = localStorage.getItem('cg_youtube_consent') || '';
function hasYouTubeConsent(consent) {
    return consent !== null && consent.includes(YOUTUBE_CONSENT_CATEGORY);
}
function loadYouTubeIframeAPI(callback) {
    var _a;
    if (window.YT && window.YT.Player) {
        callback();
        return;
    }
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.onload = () => {
        callback();
    };
    tag.onerror = () => {
        console.error('Failed to load YouTube API.');
    };
    const firstScriptTag = document.getElementsByTagName('script')[0];
    (_a = firstScriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(tag, firstScriptTag);
}
export function initVideoPodcastPlaylistBlock(context = document) {
    if (!hasYouTubeConsent(currentConsent)) {
        console.warn('⛔️ YouTube consent NOT granted. Exiting init.');
        return;
    }
    const blocks = context.querySelectorAll('.video-playlist-block');
    blocks.forEach((block) => {
        block.classList.add('has-consent');
    });
    $(context)
        .find('.video-playlist-block .playlist-slider')
        .not('.slick-initialized')
        .slick({
        centerMode: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        prevArrow: $(context).find('.video-playlist-block .playlist-slider-wrapper .playlist-slider-nav .prev-slide'),
        nextArrow: $(context).find('.video-playlist-block .playlist-slider-wrapper .playlist-slider-nav .next-slide'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: 'unslick',
            },
        ],
    });
    const videoPlayer = new VideoPlayer();
    const playListElements = context.querySelectorAll('.video-playlist-block .playlist-item');
    if (playListElements && playListElements.length > 0) {
        playListElements.forEach((playlistElement, index) => {
            playlistElement.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
                if (index === videoPlayer.currentIndex) {
                    const playerState = yield videoPlayer.getPlayerState();
                    if (playerState === 1) {
                        videoPlayer.pausePlaying();
                        playlistElement.classList.remove('is-playing');
                    }
                    else {
                        videoPlayer.resumePlaying();
                        playlistElement.classList.add('is-playing');
                    }
                }
                else {
                    resetPlayConditionForAllExceptClicked(index);
                    playlistElement.classList.add('is-playing');
                    const videoItem = videoPlayer.playFromPlaylist(index, true);
                    videoPlayer.setVideoInfo(videoItem);
                }
            }));
        });
    }
    const resetPlayConditionForAllExceptClicked = (clickedIndex) => {
        if (playListElements && playListElements.length > 0) {
            playListElements.forEach((playlistElement, index) => {
                if (index !== clickedIndex) {
                    playlistElement.classList.remove('is-playing');
                }
            });
        }
    };
}
function handleConsentMessage(event) {
    var _a;
    try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if ((data === null || data === void 0 ? void 0 : data.source) === 'preference_manager' && data.message === 'submit_preferences') {
            const consentValues = typeof data.data === 'string' ? data.data.split(',') : data.data.value.split(',');
            currentConsent = consentValues.join(',');
            localStorage.setItem('cg_youtube_consent', currentConsent);
            if (hasYouTubeConsent(currentConsent)) {
                loadYouTubeIframeAPI(() => initVideoPodcastPlaylistBlock(document));
            }
        }
        if (((_a = data === null || data === void 0 ? void 0 : data.PrivacyManagerAPI) === null || _a === void 0 ? void 0 : _a.action) === 'getConsentDecision') {
            const consentDecision = data.PrivacyManagerAPI.consentDecision;
            if (consentDecision) {
                currentConsent = consentDecision;
                localStorage.setItem('cg_youtube_consent', currentConsent);
                if (hasYouTubeConsent(currentConsent)) {
                    loadYouTubeIframeAPI(() => initVideoPodcastPlaylistBlock(document));
                }
            }
        }
    }
    catch (e) {
        console.error('❌ Error handling consent message:', e);
    }
}
function requestConsentDecision() {
    const apiObject = {
        PrivacyManagerAPI: {
            action: 'getConsentDecision',
            timestamp: new Date().getTime(),
            self: window.location.hostname,
        },
    };
    window.top.postMessage(JSON.stringify(apiObject), '*');
}
$(document).ready(() => {
    // Listen for consent messages
    window.addEventListener('message', handleConsentMessage, false);
    // Request initial consent decision
    requestConsentDecision();
    // Try initial playlist load (in case consent already exists)
    loadYouTubeIframeAPI(() => initVideoPodcastPlaylistBlock(document));
    // Add click listener to the placeholder link
    $('.accept-cookies-link').on('click', (e) => {
        e.preventDefault();
        if (typeof window.ta_click === 'function') {
            window.ta_click();
        }
        else {
            console.warn('ta_click is not defined');
        }
    });
});
window.cgBlocks = window.cgBlocks || {};
window.cgBlocks.initVideoPodcastPlaylistBlock = initVideoPodcastPlaylistBlock;
